import React, { useEffect, useState, useContext, useMemo } from "react";
import { Formik, Form, Field } from "formik";
import { TextArea } from "../TextArea/TextArea";
import { useAuth } from "../../context/AuthContext";
import { NemuContext } from "../../utils/NemuContext";
import PlacesAutocomplete from "./googleapi";
import { api } from "../../context/Auth";
import axios from "axios";
import Swal from "sweetalert2";

// Íconos
import defaultImg from "../../assets/img/default.png";
import iconAlbercaW from "../../assets/icons/White/icon-alberca.svg";
import iconGymEW from "../../assets/icons/White/gymE-w.svg";
import iconJacuzziW from "../../assets/icons/White/jacuzzi-w.svg";
import iconCoW from "../../assets/icons/White/coW-w.svg";
import iconTerrazaW from "../../assets/icons/White/terraza-w.svg";
import iconBarW from "../../assets/icons/White/bar-w.svg";
import iconRoofW from "../../assets/icons/White/roof-w.svg";
import iconPadelW from "../../assets/icons/White/padel-w.svg";
import iconLavanderiaW from "../../assets/icons/White/lavanderia-w.svg";
import iconPetW from "../../assets/icons/White/pet-w.svg";
import iconLudotecaW from "../../assets/icons/White/ludoteca-w.svg";
import iconJuegosW from "../../assets/icons/White/salon-w.svg";
import iconAsadoresW from "../../assets/icons/White/asador-w.svg";
import iconCineW from "../../assets/icons/White/cine-w.svg";
import iconDepartamento from "../../assets/Home/DepartamentIcon.svg";
import iconBodega from "../../assets/Home/warehouseIcon.svg";
import iconTerreno from "../../assets/Home/terrenoIcon.svg";
import gpsIcon from "../../assets/Home/gps.png";
import calendarIcon from "../../assets/Home/calendar.svg";
import IconArrow from "../../assets/icons/Black/arrow-left.svg";
import iconCar from "../../assets/icons/Black/icon-car-B.svg";
import saveIcon from "../../assets/Home/icon-plus.svg";
import recycleIcon from "../../assets/Home/recycleIcon.svg";
import ThreeDots from "../../assets/icons/Black/three_dots.svg";
import ShowPassword from "../../assets/icons/Black/view.png";
import HidePassword from "../../assets/icons/Black/hide.png";
import { AddCSV } from "../AddCSV";
import { set } from "react-hook-form";

const EditDevelopment = ({ development }) => {
    const amenities = development.amenities ? development.amenities.map((amenity) => amenity.id) : [];
    const { paymentPlans, user } = useAuth();
    const availableProperties = development.properties.filter((property) => property.status === "Disponible").length;
    const initialValues = useMemo(() => ({
        name: development.name || "",
        status: development.status || 'Borrador',
        amenities: amenities || [],
        description: development.description || "",
        meta_description: development.meta_description || "",
        enterprise_name: development.enterprise_name || "",
        enterprise_description: development.enterprise_description || "",
        type: development.type || "Departamento",
        address: development.address || "",
        latitude: development.latitude || 0,
        longitude: development.longitude || 0,
        applied_payment_plans: development.applied_payment_plans ? development.applied_payment_plans.split(',').map(pp => parseInt(pp)) : [],
        delivery_date: development.delivery_date || "",
        release_date: development.release_date || "",
        delivered_projects: development.delivered_projects || 0,
        floors_number: development.floors_number || 0,
        properties_number: development.properties_number || 0,
        seller_name: development.seller_name || "",
        contact_email: development.contact_email || "",
        contact_number: development.contact_number || "",
        allianceWith: development.allianceWith || "Desarrolladora",
        stateName: development.stateName || "",
        inventoryLink: development.inventoryLink || "",
        materialURL: development.materialURL || "",
        linkUser: development.linkUser || "",
        linkPassword: development.linkPassword || "",
        allianceName: development.allianceName || "",
        allianceEmail: development.allianceEmail || "",
        alliancePhone: development.alliancePhone || "",
        rightsTransfer: development.rightsTransfer || false,
        rightsNumber: development.rightsNumber ?? "",
        hasBuildingLicense: development.hasBuildingLicense || false,
    }), [development]);
    const [properties, setProperties] = useState([]);
    const [originalProperties, setOriginalProperties] = useState([]);
    const [models, setModels] = useState([]);
    const [originalModels, setOriginalModels] = useState([]);
    const [portada, setPortada] = React.useState(null);
    const [mainImageFile, setMainImageFile] = React.useState(null);
    const [secondaryImage, setSecondaryImage] = React.useState(null);
    const [imageFile, setImageFile] = React.useState(null);
    const [enterpriseImage, setEnterpriseImage] = React.useState(null);
    const [enterpriseImageFile, setEnterpriseImageFile] = React.useState(null);
    const [amenitiesImage, setAmenitiesImage] = React.useState([]);
    const [amenitiesImageFile, setAmenitiesImageFile] = React.useState([]);
    const [existingAmenitiesImages, setExistingAmenitiesImages] = React.useState([]);
    const [deletedAmenitiesImages, setDeletedAmenitiesImages] = React.useState([]);
    const [initialImages, setInitialImages] = useState([]);
    const [hasChanges, setHasChanges] = useState(false);
    const [submenuOpened, setSubmenuOpened] = useState(false);
    const [hasShadow, setHasShadow] = useState(false);
    const [savingChanges, setSavingChanges] = useState(false);
    const [externalPaymentPlans, setExternalPaymentPlans] = useState([]);
    const [type, setType] = useState(development.type || "Departamento");
    const markChanged = () => setHasChanges(true);
    const inventoryChangedRef = React.useRef(false);
    const setPropertiesAndMarkInventory = (val) => { inventoryChangedRef.current = true; setProperties(val); };
    const setModelsAndMarkInventory = (val) => { inventoryChangedRef.current = true; setModels(val); };
    const { setMyProjects, myProjects } = useAuth();
    const { setSelectedProp } = React.useContext(NemuContext);
    const [showPassword, setShowPassword] = useState(false);
    
    const availableAmenities = [
        { id: 16, name: "Alberca", icon: iconAlbercaW },
        { id: 17, name: "Jacuzzi", icon: iconJacuzziW },
        { id: 18, name: "Coworking", icon: iconCoW },
        { id: 19, name: "Pet Friendly", icon: iconPetW },
        { id: 20, name: "Terraza", icon: iconTerrazaW },
        { id: 21, name: "Cine", icon: iconCineW },
        { id: 22, name: "Sports Bar", icon: iconBarW },
        { id: 23, name: "Lavandería", icon: iconLavanderiaW },
        { id: 24, name: "Gym Equipado", icon: iconGymEW },
        { id: 25, name: "Gym Funcional", icon: iconGymEW },
        { id: 26, name: "Rooftop", icon: iconRoofW },
        { id: 27, name: "Padel", icon: iconPadelW },
        { id: 28, name: "Ludoteca", icon: iconLudotecaW },
        { id: 29, name: "Salón de Juegos", icon: iconJuegosW },
        { id: 30, name: "Asadores", icon: iconAsadoresW },
        { id: 31, name: "Cajones en venta", icon: iconCar },
    ];

    const fetchProperties = async () => {
        try {
            const response = await axios.get(`${api}/propertie/read/${development.id}`);
            //   console.log(response.data);
            const propsDoc = response.data.map((row) => ({
                key: row.id,
                propertie_id: row.propertie_id,
                floor: row.floor,
                orientation: row.orientation,
                // description: row.description,
                // type: row.type,
                // images_path: row.images_path,
                list_price: row.list_price,
                // first_payment: row.first_payment,
                // monthly_payment: row.monthly_payment,
                rooms_number: row.rooms_number,
                bathrooms_number: row.bathrooms_number,
                parking_places: row.parking_places,
                building_surface: row.building_surface,
                terrace_surface: row.terrace_surface,
                balcony_surface: row.balcony_surface,
                warehouse_surface: row.warehouse_surface,
                total_surface: row.total_surface,
                delivery_date: row.delivery_date,
                status: row.status,
                model: row.model,
                type: row.type,
                development_id: row.development_id,
            }));
        // console.log(developments);
        setOriginalProperties(propsDoc);
        setProperties(propsDoc.map(p => ({...p})));
        } catch (error) {
            console.log(error);
        }
    };

    const fetchModelsDevelopment = async () => {
        try {
        const response = await axios.get(
            `${api}/development/models/${development.id}`
        );
        // First, access the model_propierties array of the first development
        const modelProperties = response.data[0].model_propierties;

        // Then map through the model_propierties array
        const modelsAPI = modelProperties.map((model) => ({
            id: model.id,
            name: model.name,
            main_image: model.cover_page, // Changed from main_image to cover_page based on your JSON
            blueprints: model.blueprints, // Changed from units to disponibility based on your JSON
        }));

        // console.log(modelsAPI);

        // console.log(modelsAPI);
        setOriginalModels(modelsAPI);
        setModels(modelsAPI.map(m => ({...m})));
        } catch (error) {
        console.log(error);
        }
    };

    const fetchExternalPaymentPlans = async () => {
        try {
            const response = await axios.get(`${api}/paymentplan/get/user/${development.user_id}`);
            // console.log(response.data);
            console.log(response.data.message);
            
            setExternalPaymentPlans(response.data.message);
        }
        catch (error) {
            console.error("Error fetching external payment plans:", error);
        }
    };

    useEffect(() => {
        fetchExternalPaymentPlans();
    }, [development.user_id]);

    useEffect(() => {
        if(development.cover_page){
            const existingImages = development.cover_page.split(',').filter(img => img.trim() !== '').map(img => img.trim());
            const existingImagesUrls = existingImages.map(img => `${api}/${img}`);
            setExistingAmenitiesImages(existingImages);
            setAmenitiesImage(existingImagesUrls);
            setInitialImages(existingImagesUrls);
        }
    }, [development.cover_page]);

    useEffect(() => {
        fetchProperties();
        fetchModelsDevelopment();
    }, [development]);

    useEffect(() => {
        const handleScroll = () => {
          if (window.scrollY > 50) {
            setHasShadow(true);
          } else {
            setHasShadow(false);
          }
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, []);
    
    const handleDeleteDevelopment = async (id) => {
        Swal.fire({
        title: `¿Estás seguro de eliminar ${development.name}?`,
        text: "No podrás revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        }).then(async (result) => {
        if (result.isConfirmed) {
            try {
            const response = await axios.delete(
                `${api}/development/delete/${id}`
            );

            if (response.data.success) {
                Swal.fire({
                    icon: "success",
                    title: "Proyecto eliminado",
                    text: "Tu proyecto ha sido eliminado exitosamente",
                });
                console.log("Proyecto eliminado:", id);
                console.log("ids en el estado", myProjects.map(p => p.id));
                setMyProjects(projects => projects.filter((project) => project.id !== id));
                setSelectedProp(0);
            }
            } catch (error) {
            console.error("Error al eliminar el proyecto:", error.message);
            Swal.fire({
                icon: "error",
                title: "Error al eliminar proyecto",
                text: "No se pudo eliminar el proyecto. Intenta de nuevo más tarde.",
            });
            }
        }
        });
    };

    return (
        <div className="flex flex-col w-full bg-white rounded-sm p-4 gap-2 overflow-y-auto">
            <div className="flex gap-1">
                <span className={`border rounded-[24px] px-2 py-1 text-[12px] font-medium ${
                    development.status === 'Borrador' ? 'bg-[#efeef1] text-[#4c63ed] border-[#4c63ed]' :
                    development.status === 'Vendido'  ? 'bg-[#fff3e0] text-[#e65100] border-[#e65100]' :
                    'bg-[#e6f2d1] text-[#129b12] border-[#129b12]'
                }`}>{development.status}</span>
                <span className='border rounded-[24px] px-2 py-1 text-[12px] font-medium text-black border-black'>{`${availableProperties}/${development.properties.length}`} unidades disponibles</span>
            </div>
            <h1 onClick={() => console.log(development)} className="text-[24px] font-[400]">{development.name}</h1>
            <hr className="w-full"></hr>
            <Formik 
                initialValues={initialValues}
                onSubmit={async (values, handleResetForm) => {
                    const { amenities, ...rest } = values;
                    const formData = new FormData();
                    const amenitiesString = JSON.stringify(amenities);
                    setSavingChanges(true);

                    formData.append("properties", JSON.stringify(properties));
                    formData.append("models", JSON.stringify(models));
                    formData.append("inventoryChanged", String(inventoryChangedRef.current));
                    formData.append("amenities", amenitiesString);
                    formData.append("development", JSON.stringify({
                        ...rest,
                        applied_payment_plans: rest.applied_payment_plans.join(','),
                        status: rest.status,
                    }));
                    formData.append("requested_by", user.id);
                    if (mainImageFile) formData.append("main_image_file", mainImageFile);
                    if (imageFile) formData.append("image_file", imageFile);
                    if (enterpriseImageFile) formData.append("enterprise_image_file", enterpriseImageFile);
                    if (amenitiesImageFile) {
                        amenitiesImageFile.forEach((file) => {
                            formData.append(`cover_page_file`, file);
                        });
                    }

                    if(amenitiesImageFile.length > 0) {
                        formData.append("existing_amenities_images", existingAmenitiesImages.join(','));
                    }
                    else{
                        formData.append("existing_amenities_images", "");
                    }
                    if(deletedAmenitiesImages.length > 0){
                        formData.append("deleted_amenities_images", deletedAmenitiesImages.join(','));
                    }// if (changesOnPropertiesOrModels) {
                    //     formData.append("properties", JSON.stringify(properties));
                    //     formData.append("models", JSON.stringify(models));
                    // }

                    try {
                        const response = await axios.patch(`${api}/development/updateFD/${development.id}`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "Authorization": `Bearer ${user.token}`,
                            },
                        })
                        console.log(response);
                        
                        if(response.data.success) {
                            Swal.fire({
                                icon: "success",
                                title: "Cambios guardados",
                                text: "Los cambios se han guardado correctamente",
                            });
                            // Actualizar los originales para que "deshacer" vuelva al último guardado
                            setOriginalProperties(properties.map(p => ({...p})));
                            setOriginalModels(models.map(m => ({...m})));
                            setHasChanges(false);
                            inventoryChangedRef.current = false;
                        }
                        else{
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: response.data.message,
                            });
                        }
                    }
                    catch (error) {
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: error.response.data.message,
                        });
                    }
                    finally {
                        setSavingChanges(false);
                    }

                    // const data = {
                    //     amenities: JSON.stringify(amenities),
                    //     development: {
                    //         ...rest,
                    //         applied_payment_plans: rest.applied_payment_plans.join(','),
                    //         status: rest.status ? 'Publicado' : 'Borrador',
                    //     },
                    //     properties: properties,
                    //     models: models,
                    //     requested_by: user.id,
                    // }
                    // console.log(data);
                }}
            >
                {({ handleReset, values, setFieldValue }) => {
                    const changeType = (type) => {
                        setFieldValue("type", type);
                        setType(type);
                        setPropertiesAndMarkInventory([]);
                        setModelsAndMarkInventory([]);
                        markChanged();
                    };

                    const handleResetForm = () => {
                        handleReset();
                        setPortada(null);
                        setMainImageFile(null);
                        setSecondaryImage(null);
                        setImageFile(null);
                        setEnterpriseImage(null);
                        setEnterpriseImageFile(null);
                        setAmenitiesImageFile([]);
                        setSubmenuOpened(false);
                        setModels(originalModels.map(m => ({...m})));
                        setProperties(originalProperties.map(p => ({...p})));
                        setType(development.type || "Departamento");
                        setAmenitiesImage([...initialImages]);
                        setDeletedAmenitiesImages([]);
                        setHasChanges(false);
                        inventoryChangedRef.current = false;
                    };
                
                    const toggleAmenity = (amenityId) => {
                        const currentAmenities = [...values.amenities];
                        const index = currentAmenities.indexOf(amenityId);
                        
                        if (index === -1) {
                            currentAmenities.push(amenityId);
                        } else {
                            currentAmenities.splice(index, 1);
                        }
                        
                        setFieldValue("amenities", currentAmenities);
                        markChanged();
                    };

                    const isAmenitySelected = (amenityId) => {
                        return values.amenities.includes(amenityId);
                    };

                    const togglePP = (ppId, monthsNumber) => {
                        const currentPP = [...values.applied_payment_plans];
                        const index = currentPP.indexOf(ppId);

                        

                        if (index === -1) {
                            if (monthsNumber > 0) {
                                // Obtener fecha actual
                                const today = new Date();
                                const currentYear = today.getFullYear();
                                const currentMonth = today.getMonth(); // 0-indexed

                                // Obtener año y mes de delivery_date ('AAAA-MM')
                                const [deliveryYear, deliveryMonth] = development.delivery_date.split('-').map(Number);

                                // Calcular diferencia en meses
                                const diffMonths = (deliveryYear - currentYear) * 12 + (deliveryMonth - 1 - currentMonth);

                                if (diffMonths < monthsNumber) {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Plan de pagos no válido',
                                        text: `La fecha de entrega del desarrollo es menor al número de meses del plan de pagos (${monthsNumber} meses). Por favor, ajusta la fecha de entrega o selecciona otro plan de pagos.`,
                                    });
                                    return;
                                }
                            }
                            currentPP.push(ppId);
                        } else {
                            currentPP.splice(index, 1);
                        }

                        setFieldValue("applied_payment_plans", currentPP);
                        markChanged();
                    };

                    const isPPSelected = (ppId) => {
                        return values.applied_payment_plans.includes(ppId);
                    };

                    const handlePortadaChange = (event) => {
                        markChanged();
                        const file = event.target.files[0];
                        // const file2 = event.target.files;
                        setMainImageFile(file);
                        if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                setPortada(reader.result);
                            };
                            reader.readAsDataURL(file);
                        }
                    }

                    const handleSecondaryChange = (event) => {
                        markChanged();
                        const file = event.target.files[0];
                        // const file2 = event.target.files;
                        setImageFile(file);
                        if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                setSecondaryImage(reader.result);
                            };
                            reader.readAsDataURL(file);
                        }
                    }

                    const handleEnterpriseImageChange = (event) => {
                        markChanged();
                        const file = event.target.files[0];
                        // const file2 = event.target.files;
                        setEnterpriseImageFile(file);
                        if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                setEnterpriseImage(reader.result);
                            };
                            reader.readAsDataURL(file);
                        }
                    }

                    const handleAmenitiesImageChange = (event) => {
                        markChanged();
                        // const file = event.target.files[0];
                        // const files = Array.from(event.target.files).slice(0, 5); // Limitar a 5 archivos
                        // // const file2 = event.target.files;
                        // setAmenitiesImageFile(files);
                        // if (file) {
                        //     const reader = new FileReader();
                        //     reader.onloadend = () => {
                        //         setAmenitiesImage(reader.result);
                        //     };
                        //     reader.readAsDataURL(file);
                        // }
                        const currentCount = amenitiesImage ? amenitiesImage.length : 0;
                        const availableSlots = 5 - currentCount;
                        const files = Array.from(event.target.files).slice(0, availableSlots); // Limitar a 5 archivos

                        if(files.length > availableSlots) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Límite de imágenes alcanzado',
                                text: `Solo puedes subir hasta 5 imágenes. Actualmente tienes ${currentCount} imágenes.`,
                            });
                            return;
                        }

                        files.forEach((file) => {
                            if(file.type.startsWith('image/')) {
                                const reader = new FileReader();
                                reader.onload = (event) => {
                                    setAmenitiesImage((prevImages) => [...prevImages, event.target.result]);
                                    setAmenitiesImageFile((prevFiles) => [...prevFiles, file]);
                                }
                                reader.readAsDataURL(file);
                            }
                        });
                    }

                    const removeAmenitiesImage = (index) => {
                        markChanged();
                        const imageToRemove = amenitiesImage[index];

                        const existingImageIndex = existingAmenitiesImages.findIndex(
                            existingPath => `${api}/${existingPath}` === imageToRemove
                        );

                        if(existingImageIndex !== -1) {
                            // Si la imagen es una existente, la marcamos para eliminar
                            const pathToDelete = existingAmenitiesImages[existingImageIndex];
                            setDeletedAmenitiesImages((prev) => [...prev, pathToDelete]);
                            setExistingAmenitiesImages((prev) => prev.filter((_, i) => i !== existingImageIndex));
                        } else {
                            const newImageIndex = index - existingAmenitiesImages.length;
                            if(newImageIndex >= 0){
                                setAmenitiesImageFile((prevFiles) => prevFiles.filter((_, i) => i !== newImageIndex));
                            }
                        }

                        setAmenitiesImage((prevImages) => prevImages.filter((_, i) => i !== index));
                        // setAmenitiesImage((prevImages) => prevImages.filter((_, i) => i !== index));
                        // setAmenitiesImageFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
                    };

                    const prepareAmenitiesForBackend = () => {
                        return {
                            newImages: amenitiesImageFile,
                            existingImages: existingAmenitiesImages,
                            deletedImages: deletedAmenitiesImages,
                        }
                    };

                    const handleLocationSelect = (location) => {
                        setFieldValue("address", location.address, { shouldValidate: true });
                        setFieldValue("latitude", location.lat, { shouldValidate: true });
                        setFieldValue("longitude", location.lng, { shouldValidate: true });
                        markChanged();
                      };

                    // const handlePortadaChange = (event) => {
                    //     const file = event.target.files[0];
                    //     const file2 = event.target.files;
                    //     // setNewPortada(file2);
                    //     if (file) {
                    //         const reader = new FileReader();
                    //         reader.onloadend = () => {
                    //             setPortada(reader.result);
                    //         };
                    //         reader.readAsDataURL(file);
                    //     }
                    // }
                    
                    return (
                        <Form onInput={markChanged}>
                            {/* Submit, reset and delete buttons */}
                            <div className="fixed flex z-[90] right-8 top-[108px] justify-end">
                                <div
                                    className={`sticky top-20 rounded-lg flex p-2 bg-white gap-5 transition-shadow duration-300 ${
                                    hasShadow ? "shadow-md" : "shadow-none"
                                    }`}
                                >
                                    {hasChanges && (
                                    <>
                                        <div
                                        onClick={handleResetForm}
                                        className="flex py-[6px] px-3 gap-2 border border-nemu-black rounded-md justify-center items-center duration-300 text-nemu-black cursor-pointer hover:bg-nemu-platino"
                                        >
                                        <img src={IconArrow} alt="Save Icon" />
                                        <div className="text-[16px] text-nemu-black">
                                            Deshacer cambios
                                        </div>
                                        </div>
                                        <button
                                            disabled={savingChanges}
                                            type="submit"
                                            className="flex bg-nemu-azul py-1.5 px-3 gap-2 rounded-[4px] justify-center items-center duration-300 cursor-pointer hover:bg-nemu-azulOscuro"
                                        >
                                        <img src={saveIcon} alt="Save Icon" />
                                            <span className="text-white">{savingChanges ? "Guardando..." : "Guardar cambios" }</span>
                                        </button>
                                    </>
                                    )}
                                    <div className="flex justify-center items-center cursor-pointer">
                                    <img
                                        onClick={() => setSubmenuOpened((prev) => !prev)}
                                        className="py-[10px] px-[10px] bg-nemu-platino rounded-md"
                                        src={ThreeDots}
                                        alt="Edit icon"
                                    />
                                    <div
                                        onClick={() => handleDeleteDevelopment(development.id)}
                                        className="absolute items-center gap-2 top-[52px] right-2 min-w-max bg-white rounded-md rounded-tr-none p-2 shadow-md duration-300 hover:bg-nemu-platino"
                                        style={{ display: submenuOpened ? "flex" : "none" }}
                                    >
                                        <img
                                        className="cursor-pointer rounded-lg"
                                        style={{
                                            filter:
                                            "invert(60%) sepia(28%) saturate(5357%) hue-rotate(332deg) brightness(102%) contrast(105%)",
                                        }}
                                        src={recycleIcon}
                                        alt="Recycle icon"
                                        />
                                        <span>Eliminar proyecto</span>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            {/* Status */}
                            <div className="flex items-center gap-2">
                                <Field name="status">
                                    {({ field }) => (
                                        <div className="flex flex-col gap-2">
                                            <div className="flex items-center gap-3">
                                                <p className="font-[400]">Estado del proyecto</p>
                                                <select
                                                    {...field}
                                                    onChange={(e) => { field.onChange(e); markChanged(); }}
                                                    className="p-2 rounded-[4px] border-[2px] border-nemu-plata text-sm"
                                                >
                                                    <option value="Borrador">Borrador</option>
                                                    <option value="Publicado">Publicado</option>
                                                    <option value="Vendido">Vendido</option>
                                                </select>
                                            </div>
                                            {field.value === 'Publicado' && (
                                                <p className="text-[12px] text-[#6A6A6A] max-w-[540px]">
                                                    El proyecto es público y visible para todos los usuarios de la plataforma.
                                                </p>
                                            )}
                                            {field.value === 'Borrador' && (
                                                <p className="text-[12px] text-[#6A6A6A] max-w-[540px]">
                                                    El proyecto es privado y solo accesible para ti y los administradores.
                                                </p>
                                            )}
                                            {field.value === 'Vendido' && (
                                                <p className="text-[12px] text-[#6A6A6A] max-w-[540px]">
                                                    El proyecto está marcado como vendido y no aparecerá en los resultados de búsqueda.
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </Field>
                            </div>
                            {/* Nombre */}
                            <div className="flex flex-col gap-2 mt-4">
                                <label className="text-[20px] font-[500]" htmlFor="name">Nombre del proyecto</label>
                                <Field className="p-3 rounded-[4px] border-[2px] border-nemu-plata" type="text" name="name" />
                            </div>
                            {/* Descripción */}
                            <Field name="description" component={TextArea} title="Descripción" label="Descripción del proyecto" maxLength={500} />
                            {/* Meta Descripción */}
                            <Field name="meta_description" component={TextArea} title="Meta Descripción (Google)" label="Descripción del proyecto" maxLength={500} />
                            {/* Tipo */}
                            <div className="flex flex-col gap-2 mt-4">
                                <p className="text-[20px] font-[500]" htmlFor="type">Tipo de propiedad</p>
                                <label>Selecciona el tipo de propiedad, ya sea un desarrollo vertical, casa o local comercial.</label>
                                <input type="hidden" name="type" value={values.type} />
                                <div className="grid grid-cols-6 gap-6 w-max">
                                    <div onClick={() => changeType("Departamento")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Departamento" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconDepartamento}
                                                alt="Departamento"
                                                className={`w-10 ${values.type === "Departamento" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900">Departamento</span>
                                    </div>
                                    <div onClick={() => changeType("Casa")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Casa" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconBodega}
                                                alt="Casa"
                                                className={`w-10 ${values.type === "Casa" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900">Casa</span>
                                    </div>
                                    <div onClick={() => changeType("Local")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Local" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconTerreno}
                                                alt="Local"
                                                className={`w-10 ${values.type === "Local" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900">Local</span>
                                    </div>
                                    <div onClick={() => changeType("Bodega")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Bodega" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconTerreno}
                                                alt="Bodega"
                                                className={`w-10 ${values.type === "Bodega" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900">Bodega</span>
                                    </div>
                                    <div onClick={() => changeType("Terreno")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Terreno" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconTerreno}
                                                alt="Terreno"
                                                className={`w-10 ${values.type === "Terreno" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900">Terreno</span>
                                    </div>
                                    <div onClick={() => changeType("Pool de Rentas")} className="flex flex-col items-center gap-2 cursor-pointer">
                                        <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${values.type === "Pool de Rentas" ? "bg-black" : "border-[2px] border-black"}`}>
                                            <img
                                                src={iconDepartamento}
                                                alt="Pool de Rentas"
                                                className={`w-10 ${values.type === "Pool de Rentas" ? "brightness-0 invert" : ""}`}
                                            />
                                        </div>
                                        <span className="text-[12px] font-medium text-gray-900 text-center">Pool de<br/>Rentas</span>
                                    </div>
                                </div>
                            </div>
                            {/* Amenidades */}
                            {(type === 'Departamento' || type === 'Casa' || type === 'Pool de Rentas') &&
                                <div className="flex flex-col gap-2 mt-6">
                                    <p className="text-[20px] font-[500]" htmlFor="amenities">Amenidades disponibles</p>
                                    <label>Selecciona las amenidades con las que cuenta la propiedad. Si no encuentras una amenidad en nuestro listado, háznoslo saber.</label>
                                    <input type="hidden" name="amenities" value={values.amenities.join(',')} />
                                    <div className="flex flex-wrap gap-6">
                                        {availableAmenities.map((amenity) => (
                                            <div 
                                                key={amenity.id} 
                                                onClick={() => toggleAmenity(amenity.id)} 
                                                className="flex flex-col items-center gap-2 cursor-pointer"
                                                style={{ order: (amenity.id === 24 || amenity.id === 16 || amenity.id === 18 || amenity.id === 27) ? 0 : 1}}
                                            >
                                                <div className={`flex justify-center items-center w-[72px] h-[72px] rounded-2xl ${isAmenitySelected(amenity.id) ? "bg-black" : "border-[2px] border-black"}`}>
                                                    <img 
                                                        src={amenity.icon} 
                                                        alt={amenity.name} 
                                                        className={`w-10 ${isAmenitySelected(amenity.id) ? "brightness-0 invert" : "brightness-0"}`} 
                                                    />
                                                </div>
                                                <span className="text-[12px] font-medium text-center text-gray-900">{amenity.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                    {/* <div className="mt-2">
                                        <p className="text-sm text-gray-600">
                                            {values.amenities.length === 0 
                                                ? "No hay amenidades seleccionadas" 
                                                : `${values.amenities.length} amenidad${values.amenities.length > 1 ? 'es' : ''} seleccionada${values.amenities.length > 1 ? 's' : ''}`}
                                        </p>
                                    </div> */}
                                </div>
                            }
                            {/* Portada */}
                            <p className="text-[20px] font-[500] mt-4">Portada</p>
                            <span>Imagen principal que se muestra en la portada del proyecto</span>
                            <label className={`flex flex-col h-60 border-2 border-dashed border-nemu-black items-center justify-center rounded-lg relative overflow-hidden hover:bg-gray-300 cursor-pointer transition mt-2`}>
                                <img src={portada ? portada : development.main_image_path ? `${api}/${development.main_image_path}` : defaultImg } alt="img" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-30 text-white">
                                    <p className="w-full text-center mt-2 text-[20px] text-white">
                                        Drop your image here, or
                                        <span className={`text-blue-300 cursor-pointer hover:underline`}>{" "} browse.</span>
                                    </p>
                                    <span className="text-[12px] mt-4 text-white">Supports: JPG, PNG,{" "} Modo edición</span>
                                </div>
                                <input
                                    className="hidden"
                                    type="file"
                                    name="mainImage"
                                    accept="image/png, image/jpeg"
                                    onChange={handlePortadaChange}
                                />
                            </label>
                            {/* Foto Secundaria */}
                            <p className="text-[20px] font-[500] mt-4">Fotografia secundaria</p>
                            <span>Imagen secundaria del proyecto que se muestra al lado del título</span>
                            <label className={`flex flex-col h-60 border-2 border-dashed border-nemu-black items-center justify-center rounded-lg relative overflow-hidden hover:bg-gray-300 cursor-pointer transition mt-2`}>
                                <img src={secondaryImage ? secondaryImage : development.image_path ? `${api}/${development.image_path}` : defaultImg } alt="img" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-30 text-white">
                                    <p className="w-full text-center mt-2 text-[20px] text-white">
                                        Drop your image here, or
                                        <span className={`text-blue-300 cursor-pointer hover:underline`}>{" "} browse.</span>
                                    </p>
                                    <span className="text-[12px] mt-4 text-white">Supports: JPG, PNG,{" "} Modo edición</span>
                                </div>
                                <input
                                    className="hidden"
                                    type="file"
                                    name="secondaryImage"
                                    accept="image/png, image/jpeg"
                                    onChange={handleSecondaryChange}
                                />
                            </label>
                            {/* Foto Amenidades */}
                            {(type === 'Departamento' || type === 'Casa' || type === 'Pool de Rentas') &&
                                <>
                                    <p className="text-[20px] font-[500] mt-4">Imagenes Amenidades</p>
                                    <span>Imagenes que se muestran en la sección de amenidades (Máximo 5)</span>
                                    {/* Mostrar imágenes cargadas */}
                                    {amenitiesImage?.length > 0 && (
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4">
                                            {amenitiesImage.map((image, index) => (
                                                <div key={index} className="relative group">
                                                    <img 
                                                        src={image} 
                                                        alt={`Amenidad ${index + 1}`} 
                                                        className="w-full h-32 object-cover rounded-lg border-2 border-gray-300"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => removeAmenitiesImage(index)}
                                                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
                                                    >
                                                        ×
                                                    </button>
                                                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs text-center py-1 rounded-b-lg">
                                                        {index + 1} de 5
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Input para agregar más imágenes */}
                                    {amenitiesImage.length < 5 && (
                                        <label className="flex flex-col h-60 border-2 border-dashed border-nemu-black items-center justify-center rounded-lg relative overflow-hidden hover:bg-gray-300 cursor-pointer transition mt-4">
                                            <div className="flex flex-col items-center justify-center text-center p-4">
                                                <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                </svg>
                                                <p className="text-[20px] text-gray-600 mb-2">
                                                    Agregar imágenes de amenidades
                                                </p>
                                                <p className="text-gray-500">
                                                    Drop your images here, or{" "}
                                                    <span className="text-blue-500 hover:underline">browse</span>
                                                </p>
                                                <span className="text-[12px] mt-2 text-gray-400">
                                                    Supports: JPG, PNG • {5 - amenitiesImage.length} restantes
                                                </span>
                                            </div>
                                            <input
                                                className="hidden"
                                                type="file"
                                                name="amenitiesImages"
                                                accept="image/png, image/jpeg"
                                                multiple
                                                onChange={handleAmenitiesImageChange}
                                            />
                                        </label>
                                    )}

                                    {/* Mensaje cuando se alcanza el límite */}
                                    {amenitiesImage?.length >= 5 && (
                                        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                            <p className="text-blue-800 text-sm">
                                                ✓ Has alcanzado el límite máximo de 5 imágenes para amenidades.
                                            </p>
                                        </div>
                                    )}
                                </>
                            }
                            {/* Portada Desarrolladora */}
                            <p className="text-[20px] font-[500] mt-4">Portada Desarrolladora</p>
                            <span>Imagen de la desarrolladora</span>
                            <label className={`flex flex-col h-60 border-2 border-dashed border-nemu-black items-center justify-center rounded-lg relative overflow-hidden hover:bg-gray-300 cursor-pointer transition mt-2`}>
                                <img src={enterpriseImage ? enterpriseImage : development.enterprise_image_path ? `${api}/${development.enterprise_image_path}` : defaultImg } alt="img" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-30 text-white">
                                    <p className="w-full text-center mt-2 text-[20px] text-white">
                                        Drop your image here, or
                                        <span className={`text-blue-300 cursor-pointer hover:underline`}>{" "} browse.</span>
                                    </p>
                                    <span className="text-[12px] mt-4 text-white">Supports: JPG, PNG,{" "} Modo edición</span>
                                </div>
                                <input
                                    className="hidden"
                                    type="file"
                                    name="enterpriseImage"
                                    accept="image/png, image/jpeg"
                                    onChange={handleEnterpriseImageChange}
                                />
                            </label>
                            {/* Nombre desarrolladora */}
                            <div className="flex flex-col justify-between gap-2 mt-4">
                                <p className="text-[20px] font-[500] mt-4">Nombre de la desarrolladora</p>
                                <span>Escribe aquí el nombre de la desarrolladora a la que pertenece el proyecto</span>
                                <Field type="text" name="enterprise_name" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                            </div>
                            {/* Descripción desarrolladora */}
                            <Field name="enterprise_description" component={TextArea} title="Descripción de la desarrolladora" label="Descripción de desarrolladora" maxLength={500} />
                            {/* GRID 3 */}
                            <div className="w-full grid grid-cols-3 gap-4">
                                {/* Proyectos entregados */}
                                <div className="flex flex-col justify-between gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Proyectos entregados</p>
                                    <span>Número total de proyectos entregados por la desarrolladora</span>
                                    <Field type="number" name="delivered_projects" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                </div>
                                {/* Total de pisos */}
                                {(type === 'Departamento' || type === 'Casa' || type === 'Pool de Rentas') &&
                                    <div className="flex flex-col justify-between gap-2 mt-4">
                                        <p className="text-[20px] font-[500] mt-4">Total pisos</p>
                                        <span>Número de pisos del desarrollo</span>
                                        <Field type="number" name="floors_number" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                }
                                {/* Total de propiedades */}
                                <div className="flex flex-col justify-between gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Total {type === 'Local' ? "locales" : type === 'Bodega' ? 'bodegas' : type === 'Terreno' ? 'terrenos' : type === 'Pool de Rentas' ? 'unidades' : "propiedades"}</p>
                                    <span>Número total de {type === 'Local' ? "locales" : type === 'Bodega' ? 'bodegas' : type === 'Terreno' ? 'terrenos' : type === 'Pool de Rentas' ? 'unidades' : "propiedades"} existentes en el desarrollo</span>
                                    <Field type="number" name="properties_number" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                </div>
                            {/* </div>
                            GRID 3
                            <div className="w-full grid grid-cols-3 gap-4"> */}
                                {/* UBICACION */}
                                <div className="flex flex-col gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Ubicación</p>
                                    <span>Escribir dirección del desarrollo</span>
                                    <div className="flex flex-col w-full gap-1">
                                        <div className="flex justify-center items-center">
                                        <img
                                            src={gpsIcon}
                                            alt="locationIcon"
                                            className="w-5 h-auto -mr-8 z-10"
                                        />
                                        <PlacesAutocomplete
                                            defaultValue={development.address}
                                            apiKey="AIzaSyDNpgNXGvrbDB1L9EaPCvIEVAT2b3W3zn4"
                                            onSelect={handleLocationSelect}
                                        />
                                        </div>
                                    </div>
                                </div>
                                {/* Entrega */}
                                <div className="flex flex-col gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Fecha de entrega</p>
                                    <span>Escribir fecha estimada de entrega</span>
                                    <div className="flex flex-col w-full gap-1">
                                        <div className="flex justify-center items-center">
                                        <img
                                            src={calendarIcon}
                                            alt="calendarIcon"
                                            className="w-5 h-auto -mr-8 z-10"
                                        />
                                        <Field type="month" name="delivery_date" className="w-full pl-10 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                        </div>
                                    </div>
                                </div>
                                {/* Lanzxamiento */}
                                <div className="flex flex-col gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Fecha de lanzamiento</p>
                                    <span>Escribir fecha estimada de lanzamiento</span>
                                    <div className="flex flex-col w-full gap-1">
                                        <div className="flex justify-center items-center">
                                        <img
                                            src={calendarIcon}
                                            alt="calendarIcon"
                                            className="w-5 h-auto -mr-8 z-10"
                                        />
                                        <Field type="month" name="release_date" className="w-full pl-10 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                        </div>
                                    </div>
                                </div>
                            {/* </div>
                            GRID 3
                            <div className="w-full grid grid-cols-3 gap-4"> */}
                                {/* Nombre del gerente */}
                                <div className="flex flex-col justify-between gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Nombre del gerente</p>
                                    <span>Escribir nombre del gerente</span>
                                    <Field type="text" name="seller_name" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                </div>
                                {/* Correo del gerente */}
                                <div className="flex flex-col justify-between gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Correo del gerente</p>
                                    <span>Escribir correo electrónico del gerente para contacto</span>
                                    <Field type="text" name="contact_email" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                </div>
                                {/* Teléfono del gerente */}
                                <div className="flex flex-col justify-between gap-2 mt-4">
                                    <p className="text-[20px] font-[500] mt-4">Teléfono del gerente</p>
                                    <span>Escribir número de teléfono del gerente (Lada + 10 dígitos)</span>
                                    <Field type="text" name="contact_number" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                </div>
                            </div>
                            {/* Alianza */}
                            <div className="flex flex-col gap-2 mt-8">
                                <p className="text-[20px] font-[500]">Alianza</p>
                                <span>Indica si el desarrollo está en alianza con una Desarrolladora o una Inmobiliaria.</span>
                                {/* Toggle Desarrolladora / Inmobiliaria */}
                                <div className="flex gap-4 mt-2">
                                    <div
                                        onClick={() => {
                                            setFieldValue("allianceWith", "Desarrolladora");
                                            setFieldValue("stateName", "");
                                            markChanged();
                                        }}
                                        className={`flex items-center justify-center px-6 py-3 rounded-2xl cursor-pointer text-sm font-medium transition ${values.allianceWith === "Desarrolladora" ? "bg-black text-white" : "border-[2px] border-black text-black"}`}
                                    >
                                        Desarrolladora
                                    </div>
                                    <div
                                        onClick={() => { setFieldValue("allianceWith", "Inmobiliaria"); markChanged(); }}
                                        className={`flex items-center justify-center px-6 py-3 rounded-2xl cursor-pointer text-sm font-medium transition ${values.allianceWith === "Inmobiliaria" ? "bg-black text-white" : "border-[2px] border-black text-black"}`}
                                    >
                                        Inmobiliaria
                                    </div>
                                </div>
                                {/* Nombre de inmobiliaria (solo si es Inmobiliaria) */}
                                {values.allianceWith === "Inmobiliaria" && (
                                    <div className="flex flex-col gap-2 mt-2">
                                        <p className="text-[16px] font-[500]">Nombre de la Inmobiliaria</p>
                                        <Field type="text" name="stateName" placeholder="Nombre de la inmobiliaria" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                )}
                                {/* Datos de contacto de la Alianza */}
                                <div className="w-full grid grid-cols-3 gap-4 mt-4">
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Nombre de la Alianza</p>
                                        <span className="text-sm">Nombre de contacto de la alianza</span>
                                        <Field type="text" name="allianceName" placeholder="Nombre de contacto" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Correo de la Alianza</p>
                                        <span className="text-sm">Correo electrónico de contacto</span>
                                        <Field type="email" name="allianceEmail" placeholder="correo@ejemplo.com" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Teléfono de la Alianza</p>
                                        <span className="text-sm">Número de teléfono de contacto</span>
                                        <Field type="text" name="alliancePhone" placeholder="Lada + 10 dígitos" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                </div>
                                {/* Links de inventario y material */}
                                <div className="w-full grid grid-cols-2 gap-4 mt-4">
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Link de Inventario</p>
                                        <span className="text-sm">URL donde se encuentra el inventario compartido por la alianza</span>
                                        <Field type="url" name="inventoryLink" placeholder="https://..." className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Link de Material</p>
                                        <span className="text-sm">URL donde se encuentra el material compartido por la alianza</span>
                                        <Field type="url" name="materialURL" placeholder="https://..." className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                </div>
                                {/* Credenciales de acceso */}
                                <div className="w-full grid grid-cols-2 gap-4 mt-4">
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Usuario de acceso</p>
                                        <span className="text-sm">Usuario para acceder a los links de material (si aplica)</span>
                                        <Field type="text" name="linkUser" placeholder="Usuario" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <p className="text-[16px] font-[500]">Contraseña de acceso</p>
                                        <span className="text-sm">Contraseña para acceder a los links de material (si aplica)</span>
                                        <div className="flex items-center">
                                            <Field type={showPassword ? "text" : "password"} name="linkPassword" placeholder="Contraseña" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                            <img src={showPassword ? HidePassword : ShowPassword} alt="toggle" className="w-5 h-5 -ml-8 cursor-pointer" onClick={() => setShowPassword(!showPassword)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Cesión de Derechos */}
                            <div className="flex flex-col gap-2 mt-8">
                                <p className="text-[20px] font-[500]">Cesión de Derechos</p>
                                <span>Indica si el desarrollo cuenta con cesión de derechos.</span>
                                <Field name="rightsTransfer">
                                    {({ field }) => (
                                        <div className="flex flex-col gap-2">
                                            <div className="flex items-center gap-2">
                                                <p className="font-[400]">Cesión de derechos</p>
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        {...field}
                                                        checked={field.value}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            if (!e.target.checked) {
                                                                setFieldValue("rightsNumber", "");
                                                            }
                                                            markChanged();
                                                        }}
                                                        className="sr-only peer"
                                                    />
                                                    <div className="w-8 h-4 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-300 transition-all duration-300"></div>
                                                    <div className="absolute w-4 h-4 bg-white rounded-full border border-nemu-azul shadow peer-checked:translate-x-full transition-transform duration-300"></div>
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </Field>
                                {values.rightsTransfer && (
                                    <div className="flex flex-col gap-2 mt-2 max-w-xs">
                                        <p className="text-[16px] font-[500]">Número de cesiones</p>
                                        <span className="text-sm">Número de cesiones permitidas (0 a 6)</span>
                                        <Field type="number" name="rightsNumber" min="0" max="6" placeholder="0" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-grey" />
                                    </div>
                                )}
                            </div>
                            {/* Licencia de construcción */}
                            <div className="flex flex-col gap-2 mt-8">
                                <p className="text-[20px] font-[500]">Licencia de construcción</p>
                                <span>Indica si el desarrollo cuenta con licencia de construcción.</span>
                                <Field name="hasBuildingLicense">
                                    {({ field }) => (
                                        <div className="flex items-center gap-2">
                                            <p className="font-[400]">Cuenta con licencia</p>
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    {...field}
                                                    checked={field.value}
                                                    onChange={(e) => { field.onChange(e); markChanged(); }}
                                                    className="sr-only peer"
                                                />
                                                <div className="w-8 h-4 bg-gray-200 rounded-full peer peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-300 transition-all duration-300"></div>
                                                <div className="absolute w-4 h-4 bg-white rounded-full border border-nemu-azul shadow peer-checked:translate-x-full transition-transform duration-300"></div>
                                            </label>
                                        </div>
                                    )}
                                </Field>
                            </div>
                            {/* Última actualización de inventario (solo lectura) */}
                            {development.lastInventoryUpdate && (
                                <div className="flex items-center gap-2 mt-6 p-3 bg-gray-50 rounded-lg border border-gray-200">
                                    <span className="text-sm text-gray-500">Última actualización de inventario:</span>
                                    <span className="text-sm font-medium text-gray-700">{new Date(development.lastInventoryUpdate).toLocaleString('es-MX')}</span>
                                </div>
                            )}
                            {/* Planes de pago */}
                            <div className="flex flex-col gap-2 mt-6">
                                <p onClick={() => console.log(paymentPlans, externalPaymentPlans)} className="text-[20px] font-[500]" htmlFor="amenities">Planes de pago</p>
                                <label>Selecciona los planes de pago que aplicarán para el proyecto en base a los registrados en tu perfil.</label>
                                <input type="hidden" name="amenities" value={values.applied_payment_plans.join(',')} />
                                <div className="flex flex-wrap gap-6">
                                    {development.user_id === user.id ?
                                    paymentPlans.map((pp) => (
                                        <div key={pp.id} onClick={() => togglePP(pp.id, pp.monthsNumber)} className="flex flex-wrap items-center gap-2 cursor-pointer">
                                            <div className={`flex flex-col justify-start items-center px-3 py-2 text-sm rounded-2xl ${isPPSelected(pp.id) ? "bg-black text-white" : "border-[2px] border-black"}`}>
                                                <h1 className="text-lg font-semibold">{pp.name}</h1>
                                                <span>Descuento: {pp.discount}%</span>
                                                <span>Enganche: {pp.initialPayment}%</span>
                                                <span>Mensualidad: {pp.monthlyPayment}%</span>
                                                <span>A entrega: {pp.giveProperty}%</span>
                                                <span>No. Meses: {pp.monthsNumber > 0 ? pp.monthsNumber : 'N/A'}</span>
                                            </div>
                                        </div>
                                        ))
                                    :
                                    externalPaymentPlans.map((pp) => (
                                        <div key={pp.id} onClick={() => togglePP(pp.id)} className="flex flex-wrap items-center gap-2 cursor-pointer">
                                            <div className={`flex flex-col justify-start items-center px-3 py-2 text-sm rounded-2xl ${isPPSelected(pp.id) ? "bg-black text-white" : "border-[2px] border-black"}`}>
                                                <h1 className="text-lg font-semibold">{pp.name}</h1>
                                                <span>Descuento: {pp.discount}%</span>
                                                <span>Enganche: {pp.initialPayment}%</span>
                                                <span>Mensualidad: {pp.monthlyPayment}%</span>
                                                <span>A entrega: {pp.giveProperty}%</span>
                                            </div>
                                        </div>
                                        ))
                                    }
                                </div>
                                {/* <div className="mt-2">
                                    <p className="text-sm text-gray-600">
                                        {values.amenities.length === 0 
                                            ? "No hay amenidades seleccionadas" 
                                            : `${values.amenities.length} amenidad${values.amenities.length > 1 ? 'es' : ''} seleccionada${values.amenities.length > 1 ? 's' : ''}`}
                                    </p>
                                </div> */}
                            </div>
                            {/* Propiedades */}
                            <div className="my-10">
                                <AddCSV properties={properties} setProperties={setPropertiesAndMarkInventory} models={models} setModels={setModelsAndMarkInventory} setOriginalModels={setOriginalModels} type={type} onUserChange={markChanged}/>
                            </div>
                            <div className="flex justify-start bg-[#E5E1FC] w-full rounded py-[7px] px-[12px] ">
                                <span className="text-[16px] ">
                                    Exporta el archivo en formato CSV.
                                    <br />
                                    Asegúrate que el orden de las columnas es el correcto.
                                    <br />
                                    Si no cuentas con un archivo, puedes descargar uno{" "}
                                    <a
                                        href={type === 'Departamento' ? "./ejemplo_departamentos.csv" : type === 'Casa' ? "./ejemplo_casas.csv" : type === 'Local' ? "./ejemplo_locales.csv" : type === 'Terreno' ? "./ejemplo_terrenos.csv" : type === 'Pool de Rentas' ? "./ejemplo_pool_rentas.csv" : "./ejemplo_bodegas.csv"}
                                        download={type === 'Departamento' ? "ejemplo_departamentos.csv" : type === 'Casa' ? "ejemplo_casas.csv" : type === 'Local' ? "ejemplo_locales.csv" : type === 'Terreno' ? "ejemplo_terrenos.csv" : type === 'Pool de Rentas' ? "ejemplo_pool_rentas.csv" : "ejemplo_bodegas.csv"}
                                        className="cursor-pointer text-[16px] font-medium text-nemu-azul underline "
                                    >
                                    presionando aquí.
                                    </a>
                                </span>
                            </div>
                            {/* SUBMIT TEMPORAL */}
                            {/* <button type="submit" className={`flex items-center gap-2 mt-6 bg-nemu-azul text-white rounded-[4px] px-4 py-2 ${!dirty ? "opacity-50 cursor-not-allowed" : ""}`} disabled={!dirty}>
                                Guardar cambios
                            </button> */}
                        </Form>
                    );
                }}   
            </Formik>
        </div>
    );
}

export { EditDevelopment };